/**
 * Component Registry for Piper Lofts
 * 
 * Inherits from @vibesites-price-brothers/theme-vantage and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-vantage/registry';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { HeroSolidBG } from './components/HeroSolidBG';
import { PropertyOverview } from './components/PropertyOverview';
import { NeighborhoodSection } from './components/NeighborhoodSection';
import { ApplyNow } from './components/ApplyNow';
import { ResidentAccess } from './components/ResidentAccess';
import { ContactForm } from './components/ContactForm';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { Footer } from './components/Footer';
import { PageBlurb } from './components/PageBlurb';
import { SitemapContent } from './components/SitemapContent';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  Hero,
  HeroSolidBG,
  PropertyOverview,
  NeighborhoodSection,
  ApplyNow,
  ResidentAccess,
  ContactForm,
  ScheduleTourForm,
  Footer,
  PageBlurb,
  SitemapContent,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
